import { chatEE } from '@/layout';
import { useEffect, useState } from 'react';
import type { ShowMessageReactionsPayload } from '../models/message-reaction-dialog-types';

/**
 * Hook để quản lý state của message reaction dialog
 * Sử dụng hook này trong component muốn hiển thị dialog
 */
export const useMessageReactionDialog = () => {
  const [dialogState, setDialogState] = useState<{
    open: boolean;
    data: ShowMessageReactionsPayload | null;
  }>({
    open: false,
    data: null
  });

  useEffect(() => {
    const handleShowMessageReactions = (payload: ShowMessageReactionsPayload) => {
      setDialogState({
        open: true,
        data: payload
      });
    };

    // Listen for show-message-reactions event
    chatEE.on('show-message-reactions', handleShowMessageReactions);

    // Cleanup listener on unmount
    return () => {
      chatEE.off('show-message-reactions', handleShowMessageReactions);
    };
  }, []);

  const close = () => {
    setDialogState({
      open: false,
      data: null
    });
  };

  return {
    open: dialogState.open,
    data: dialogState.data,
    close
  };
};
